import styled from 'styled-components';
import { playFontSize } from '../../../../ui-components/typography/helpers';
import PlayText from '../../../../ui-components/typography/PlayText/PlayText';
import { PlayTextStyles } from '../../../../ui-components/typography/PlayText/PlayText.styles';

export const StyledHighlights = styled.nav`
    margin-top: 1.5em;
`;

export const HighlightList = styled.ol`
    padding: 0;
    margin: 0;
`;

export const Highlight = styled.li`
    display: flex;
    flex-direction: row;
    margin-bottom: 7px;
`;

export const HighlightPosition = styled(PlayText)`
    margin-right: 15px;
`;

export const HighligthLink = styled.a`
    ${PlayTextStyles}
    ${playFontSize(1.6)}
    cursor: pointer;
    text-decoration: underline;
`;
